// extracted by mini-css-extract-plugin
export var childrenContainer = "_bn-0";
export var virtualScrollArea = "_bn-1";